<template>
   <div class="btns-template">
        <!--v-if="shownInDropdown"-->
        <vs-dropdown vs-trigger-click>
            <vs-button class="btn-drop" type="border" size="small" icon="expand_more"></vs-button>
            <vs-dropdown-menu>
                <vs-dropdown-item
                    v-for="(btn, index) in templateArgs.btns"
                    :key="index"
                    v-show="btn.show"
                    @click="btn.clickHandler(templateArgs)"
                    divider>
                    <i v-if="btn.icon" :class="btn.icon"></i>
                    {{ btn.text ? btn.text : (btn.tooltip ? btn.tooltip : '') }}
                </vs-dropdown-item>
            </vs-dropdown-menu>
        </vs-dropdown>
   </div>

</template>


<script>
    export default {
        name: 'gridBtnsTemplate',
        props: {
            shownInDropdown: {
                type: Boolean,
                default: false
            },
            showRight: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                templateArgs: {}
            };
        },
        mounted() {
            const container = $(this.$el);

            if (container) {
                container.find('[data-toggle="tooltip"]').tooltip({ container })
                container.closest("td").css('paddingBottom', '0')
            }
        },
        methods: {}
    };
</script>

<style scoped>

</style>
